import axios from "axios";

import { baseUrl } from "../variables/variables";

/*
 * Adapter For API server
 *
 * List Client Master returning promises */
const getToolsubmissions = async () => {
  try {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(baseUrl + "/tool-submissions", settings);
    return response.data;
  } catch (error) {
    console.error("Error fetching tool submissions:", error);
    throw error;
  }
};

const getToolsubmissionsByUser = async () => {
  try {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const userId = localStorage.getItem("userId");

    const response = await axios.get(
      `${baseUrl}/tool-submissions/users/${userId}`,
      settings
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching tool submissions:", error);
    throw error;
  }
};

const updateToolSubmissionStatus = async (baseUrl, submissionId, status) => {
  try {
    const response = await axios.put(
      `${baseUrl}/tool-submissions/${submissionId}`,
      {
        status: status,
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
const refreshToolSubmission = async (id) => {
  try {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(
      baseUrl + "/tool-submissions/" + id,
      settings
    );
    return response.data;
  } catch (error) {
    console.error("Error refreshing tool submission:", error);
    throw error;
  }
};

const getToolName = async (toolId) => {
  try {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(baseUrl + "/tools/" + toolId, settings);
    return response;
  } catch (error) {
    console.error("Error fetching tool name:", error);
    throw error;
  }
};

const getTool = async (toolId) => {
  try {
    const settings = {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(baseUrl + "/tools/" + toolId, settings);
    return response;
  } catch (error) {
    console.error("Error fetching tool name:", error);
    throw error;
  }
};
export {
  getToolName, getToolsubmissions, getToolsubmissionsByUser, refreshToolSubmission, updateToolSubmissionStatus
};

